import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { GuestExitSurveyService } from '../guest-exit-survey.service';
import { GuestExitSurvey } from '../guest-exit-survey';
import { PropertyService } from '@app/_components/property/property.service';
import { first } from 'rxjs';
import { ReviewService } from '@app/_components/review/review.service';
import { ReviewComponent } from '@app/_components/review/components/review/review.component';
import { Review } from '@app/_components/review/review';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-guest-exit-survey',
    templateUrl: './guest-exit-survey.component.html',
    styleUrls: ['./guest-exit-survey.component.css'],
    providers: [MessageService, ConfirmationService, DialogService],
    standalone: false
})
export class GuestExitSurveyComponent implements OnInit {
	properties: any[]=[];
	review: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private guestExitSurveyService: GuestExitSurveyService,
		private dialogRef: MatDialogRef<GuestExitSurveyComponent>,
		private alertService: AlertService,
		private reviewService: ReviewService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private propertyService: PropertyService,
		public dialogService: DialogService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.guestExitSurvey = data.guestExitSurvey,
			this.statuses = guestExitSurveyService.statuses;
			if(this.guestExitSurvey?.reviewId != null){
				this.findReviewById(this.guestExitSurvey?.reviewId);
			}
	}

	@Input() guestExitSurvey: GuestExitSurvey;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	guestExitSurveyId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'guestExitSurveyId': [],
		receiveDate: [],
			reservationistRank: [],
			reservationistFeedbackDesc: [],
			vehicleReservationProcessRank: [],
			vehicleRentalCompanyRank: [],
			vehicleQualityRank: [],
			vehicleFeedbackDesc: [],
			preArrivalInfoRank: [],
			preArrivalFeedbackDesc: [],
			checkinProcessRank: [],
			checkinFeedbackDesc: [],
			constructiveFeedbackDesc: [],
			propertyPresentationRank: [],
			propertyMaintenanceRank: [],
			propertyFeedbackDesc: [],
			guestServicesQualityRank: [],
			overallExperienceRank: [],
			overallExperienceFeedbackDesc: [],
			guestName: [],
			guestEmail: [{ type: 'required', message: 'Email is required' },
			{ type: 'email', message: 'Enter a valid email address' }],
			guestPhone: [],
			guestFollowupRequest: [],
			guestFollowupDate: [],
			opsNotes: [],
			managementReviewDate: [],
			managementReviewByName: [],
			title: [],
			shortTermRentalId: [{ type: 'required', message: 'Required' }],
			reservationId: [{ type: 'required', message: 'Required' }],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.fetchProperties();

		// if we were passed the whole guestExitSurvey object
		if (this.guestExitSurvey) {
			this.guestExitSurveyId = this.guestExitSurvey.guestExitSurveyId;
			if(this.guestExitSurvey.receiveDate != undefined && this.guestExitSurvey.receiveDate != null){
				this.guestExitSurvey.receiveDate = moment(this.guestExitSurvey.receiveDate).toDate();
			}
			if(this.guestExitSurvey.guestFollowupDate != undefined && this.guestExitSurvey.guestFollowupDate != null){
				this.guestExitSurvey.guestFollowupDate = moment(this.guestExitSurvey.guestFollowupDate).toDate();
			}
			this.fixDates();
			this.form1.patchValue(this.guestExitSurvey);
		}
	}

	fetchProperties() {
		try {
			this.propertyService.findAllSummaryWithStatusActive()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						
						return this.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.guestExitSurveyId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.guestExitSurveyService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestExitSurvey = res.data.guestExitSurvey;
						this.doAdd.emit(this.guestExitSurvey);
					},
					(err: any) => {
						console.log('guestExitSurvey-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('guestExitSurvey: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.guestExitSurveyService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestExitSurvey = res.data.guestExitSurvey;
						this.doUpdate.emit(this.guestExitSurvey);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.guestExitSurveyService.delete(this.guestExitSurvey.guestExitSurveyId)
				.subscribe(
					(res: any) => {
						console.log('guestExitSurvey-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.guestExitSurvey);
					},
					(err: any) => {
						console.log('guestExitSurvey-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			guestExitSurveyId: [this.guestExitSurveyId],
			receiveDate: [],
			reservationistRank: [],
			reservationistFeedbackDesc: [],
			vehicleReservationProcessRank: [],
			vehicleRentalCompanyRank: [],
			vehicleQualityRank: [],
			vehicleFeedbackDesc: [],
			preArrivalInfoRank: [],
			preArrivalFeedbackDesc: [],
			checkinProcessRank: [],
			checkinFeedbackDesc: [],
			constructiveFeedbackDesc: [],
			propertyPresentationRank: [],
			propertyMaintenanceRank: [],
			propertyFeedbackDesc: [],
			guestServicesQualityRank: [],
			overallExperienceRank: [],
			overallExperienceFeedbackDesc: [],
			guestName: [],
			guestEmail: ['', Validators.compose([
				Validators.required,
				Validators.email
			])],
			guestPhone: [],
			guestFollowupRequest: [],
			guestFollowupDate: [],
			opsNotes: [],
			managementReviewDate: [],
			managementReviewByName: [],
			shortTermRentalId: ['', Validators.required],
			reservationId: ['', Validators.required],
			title: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.guestExitSurvey.guestExitSurveyDate = moment(this.guestExitSurvey.guestExitSurveyDate).toDate();
	}

	findReviewById(reviewId: number) {
		this.formLoading = true;
		this.reviewService.findById(reviewId).pipe(first()).subscribe(
			res => {
				this.review = res.data.review;

			},
			err => {
				console.log('error In findReviewById is: ' + JSON.stringify(err));
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your review: ' + err.message, sticky: true });
			},
			() => { this.formLoading = false; });
	}

	openReviewDialog() {
		if (this.guestExitSurvey.reviewId != null) {
			this.dialogRef.close();
			const ref = this.dialogService.open(ReviewComponent, {
				data: {
					review: this.review,
				},
				header: 'Review',
				width: '80%',
				closeOnEscape: true
			});
		} else {
			this.messageService.add({ severity: 'info', summary: 'Not Exist', detail: 'This survey is not exist into guest review.', life: 3000 });

		}
	}
}
